import { memo as Memo, useMemo } from 'react'

// * Context
import { withDataContext } from 'context'

//* Components
import { Page, LottieAnimation } from 'components/common'
import { TitleSection, IndividualHeroSection, InfoSection, RelatedSection } from 'components/pages'

import loadingAnimation from 'lottieAnimation/global/loading.json'

//! Style
import BlogIndividualStyle from 'styles/pages/BlogIndividualStyle'
import BlogStyle from 'styles/pages/BlogStyle'

const BlogIndividual = Memo(({ singleBlog, pageParams, selectedLang }) => {
	const pageData = useMemo(() => singleBlog?.[pageParams.selectedSlug]?.[selectedLang], [singleBlog, pageParams, selectedLang])

	return pageData ? (
		<Page meta={pageData.post?.meta}>
			<TitleSection title={pageData.post?.title} />
			<IndividualHeroSection postData={pageData.post} />
			<BlogIndividualStyle className='FlexBox'>
				<InfoSection infoData={pageData.post?.description} />
				{pageData.relatedPosts?.length > 0 ? <RelatedSection relatedData={pageData.relatedPosts} /> : ''}
			</BlogIndividualStyle>
		</Page>
	) : (
		<BlogStyle>
			<Page className='lottieSection FlexBox AlignCenter AlignMiddle'>
				<LottieAnimation animData={loadingAnimation} isPlay={true} autoplay={true} loop={true} />
			</Page>
		</BlogStyle>
	)
})

export default withDataContext(BlogIndividual, ['singleBlog'])
